export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtDodavatel';
export const NAME = 'Dodavatel';
export const CUSTOMER_FILES = 'CustomerFiles';
export const SUPPLIER_EDIT_HISTORY = 'SupplierEditHistory';
export const DEPENDENT_TABLES = <const>[
	CUSTOMER_FILES,
	SUPPLIER_EDIT_HISTORY,
];
export enum VENDOR_STATUS {
	UnApproved = 0,
	Approved = 1,
	Rejected = 2,
}
export type DependentTableNames = typeof DEPENDENT_TABLES[number];
export const LOCAL_SUPPLIER = 2;
